export default {
	en: require('./en').default
}